import Grid from "@mui/material/GridLegacy"
import dynamic from "next/dynamic"

const CategorySort = dynamic(() => import("./CategorySort"));
const CategoryFiltersAndMenu = dynamic(() => import("./CategoryFiltersAndMenu"));

const CategorySortAndFilters = (props) => {
    return (
        <Grid className="p-2" container>
            <CategorySort />

            <CategoryFiltersAndMenu
                {...props}
            />
        </Grid>
    )
}

export default CategorySortAndFilters